<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="overlay"></div>
    </parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <iframe
          width="100%"
          height="60"
          frameborder="0"
          style="border:0"
          src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ0yUmzTWmMI4RmYX1pUtl2pw&key=AIzaSyB8yS0zaRnsxvXlMcB-5PIn62nPYLpZ0nI"
          allowfullscreen
        ></iframe>

        <div class="container">
          <div class="md-layout"></div>
        </div>
        <div class="description text-center">
          <h3 class="title">Carrera 2A #44-54</h3>
          <hr />
          <h5>MANZANARES - CALI</h5>
          <p>
            Nos encontramos ubicados en la ciudad de Cali. Valle del cauca.
          </p>
          <md-button href="tel:+573175160987" class="contact-button md-simple">
            <i class="fas fa-phone"></i> ⠀(+57) 2 379 7172
          </md-button>
          <md-button
            href="https://wa.me/573175160987"
            class="contact-button md-simple"
            target="_blank"
          >
            <i class="fab fa-whatsapp"></i> (+57) 317 516 0987
          </md-button>
        </div>
      </div>
      <div class="section section-contacts">
        <div class="container">
          <div class="md-layout  contact-master">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
              <h2 class="text-center title">Déjanos asesorarte</h2>
              <h4 class="text-center description">
                Describe detalles sobre tu proyecto o necesidad, responderemos
                en un par de horas.
              </h4>
              <form class="contact-form" @submit.prevent="sendEmail">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Nombre</label>
                      <md-input v-model="name" type="text"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Correo</label>
                      <md-input v-model="email" type="email"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Ciudad</label>
                      <md-input v-model="ciudad" type="text"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Teléfono</label>
                      <md-input v-model="telefono" type="tel"></md-input>
                    </md-field>
                  </div>
                </div>
                <md-field maxlength="5">
                  <label>Mensaje</label>
                  <md-textarea v-model="message"></md-textarea>
                </md-field>
                <div class="md-layout">
                  <div class="md-layout-item md-size-33 mx-auto text-center">
                    <md-button type="submit" class="md-success"
                      >Enviar mensaje</md-button
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  bodyClass: "profile-page",
  data() {
    return {
      name: null,
      email: null,
      message: null,
      telefono: null,
      ciudad:null
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/contactanos.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {
    sendEmail: function(e) {
      
      var data = this;
      var template_params = {
        reply_to: data.email,
        from_name: data.name,
        to_name: "Ingenieria y soluciones civiles",
        telefono: data.telefono,
        ciudad: data.ciudad,
        message_html: data.message
      };

      var service_id = "isc";
      var template_id = "template_f2p69cBy";
      emailjs.send(service_id, template_id, template_params).then(
        result => {
          data.name = null;
          data.email = null;
          data.message = null;
          alert("tu mensaje ha sido enviado");
        },
        error => {
          alert("No se pudo enviar tu mensaje, intenta de nuevo");
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
